import React from 'react';
import { colors } from '../tokens';

const SIZES = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 56,
  xl: 72,
};

const Avatar = ({ initials = '?', color = colors.brand, size = 'md', onClick, ring }) => {
  const dim = typeof size === 'number' ? size : SIZES[size];
  const fontSize = Math.round(dim * 0.38);

  return (
    <div
      onClick={onClick}
      style={{
        width: dim,
        height: dim,
        flexShrink: 0,
        borderRadius: '50%',
        background: color,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'inherit',
        fontWeight: 600,
        fontSize,
        letterSpacing: 0.2,
        userSelect: 'none',
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: ring ? `0 0 0 3px ${ring}` : 'none',
      }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
